import { Branch } from 'inventory-web'
import { InventoryLocationFormState } from '../../InventoryLocationForm'

export default async function validateForm( formState: InventoryLocationFormState, validateBranchAndName: ( name: string, branch?: Branch ) => Promise<any>, isEditMode?: boolean ) {
	const { branch, name } = formState
	const newFormState = { ...formState }
	let isInvalid = false

	// first, reset validation
	newFormState.validation = {
		branch: { isInvalid: false },
		name: { isInvalid: false },
	}

	if ( !branch && !isEditMode ) {
		newFormState.validation.branch = {
			isInvalid: true,
			error: 'Branch is required',
		}
		isInvalid = true
	}

	if ( name === '' ) {
		newFormState.validation.name = {
			isInvalid: true,
			error: 'Name is required',
		}
		isInvalid = true
	}

	if ( !isInvalid && ( branch || isEditMode ) ) {
		const validation = await validateBranchAndName( name, branch )
		if ( validation.isInvalid === true ) {
			isInvalid = true
			newFormState.validation.name = validation
		}
	}

	return {
		newFormState,
		isInvalid,
	}
}
